<template>
    <v-card>
        <v-card-title>
            <h3>{{ $t('Выберите тип хранилища ключа для ЭЦП') }}</h3>
        </v-card-title>
        <v-card-text>
            <v-select v-model="selectedStorageType" :items="typeOfStorages" :label="$t('Выберите')" class="pl-2 pr-2"></v-select>
            <p style="color:red">{{ this.errorMessage }}</p>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" rounded class="mr-3" outlined @click="onCloseECPDialog(false)">{{ $t('Отмена') }}</v-btn>
            <v-btn :disabled="!selectedStorageType" color="gray" rounded class="white--text" @click="signData">{{ $t('Продолжить') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { createCMSSignatureFromBase64 } from '@/services/sign.service';
import { NCALYER_NOT_CONNECTED, NCALYER_ERROR_ACTION_CANCELED } from '@/config/consts';

export default {
    name: 'EDSSign',
    props: ['document'],
    data: () => ({
        showStorageTypeDialog: false,
        selectedStorageType: 'PKCS12',
        resolvedPromise: null,
        dataToSign: {},
        loading: false,
        errorMessage: '',
        signedData: null
    }),
    computed: {
        typeOfStorages() {
            return [
                { text: this.$t('Ваш Компьютер'), value: 'PKCS12' },
                { text: this.$t('Казтокен'), value: 'AKKaztokenStore' },
                { text: this.$t('Личное Удостоверение'), value: 'AKKZIDCardStore' },
                { text: this.$t('EToken Java 72k'), value: 'AKEToken72KStore' },
                { text: this.$t('AK JaCarta'), value: 'AKJaCartaStore' }
            ];
        }
    },
    methods: {
        async signData() {
            this.loading = true;
            this.dataToSign = this.document;
            const { body, status, message, code } = await createCMSSignatureFromBase64(this.dataToSign, this.selectedStorageType);
            if (status) {
                this.signedData = body.result;
                this.errorMessage = '';
                this.$emit('getEDSData', this.signedData);
            } else {
                if (code === NCALYER_NOT_CONNECTED) {
                    this.errorMessage = 'Не запущен Ncalayer';
                } else if (code === NCALYER_ERROR_ACTION_CANCELED) {
                    this.errorMessage = 'Действие было отменено';
                } else {
                    this.errorMessage = code + ' ' + message;
                }
            }
            this.loading = false;
        }
    }
};
</script>

<style lang="scss"></style>
